import React from "react";
import { Chip } from "@mui/joy";
import type { SxProps } from "@mui/joy/styles/types";

// Visually hidden, still read by screen readers.
const srOnly: React.CSSProperties = {
  position: "absolute",
  width: 1,
  height: 1,
  overflow: "hidden",
  clip: "rect(0 0 0 0)",
  whiteSpace: "nowrap",
};

// A count chip for sighted users and ", N active" for screen readers, so the
// control it sits in is announced as e.g. "Filters, 2 active". Nothing at 0.
export const ActiveCountBadge: React.FC<{ count: number; sx?: SxProps }> = ({
  count,
  sx,
}) =>
  count > 0 ? (
    <>
      <Chip size="sm" variant="soft" color="primary" aria-hidden sx={sx}>
        {count}
      </Chip>
      <span style={srOnly}>, {count} active</span>
    </>
  ) : null;
